/* eslint-disable no-loop-func */
import React, { useState } from 'react'
import {
  Box,
  Button,
  DialogContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow
} from '@material-ui/core'
import { blueGrey } from '@material-ui/core/colors'

import { Modal, ModalTitle } from 'asterX-UI/Modals'
import { PRIMARY_COLORS } from 'asterX-UI'

export default function CarRepairReport({ value }) {
  const [open, setOpen] = useState(false)

  if (value === null) {
    return null
  }

  const handleClose = () => {
    setOpen(false)
  }

  let totalExpenses = 0
  let partsExpenses = 0
  let laborExpenses = 0

  const technicalInspectionList = [
    'technicalInspectionBrakeSystem',
    'technicalInspectionCoolingSystem',
    'technicalInspectionEngine',
    'technicalInspectionHeating',
    'technicalInspectionPowerSupply',
    'technicalInspectionSafety',
    'technicalInspectionSteering',
    'technicalInspectionSuspension',
    'technicalInspectionTransmission',
    'technicalInspectionWheelDrive',
    'inspectionExternalPurch',
    'inspectionInternalPurch'
  ]

  for (let techInspectionItem of technicalInspectionList) {
    value[techInspectionItem] &&
      Object.keys(value[techInspectionItem]).forEach(function (key) {
        if (value[techInspectionItem][key].expensesParts !== undefined) {
          value[techInspectionItem][key].expensesParts.forEach(exp => {
            totalExpenses = totalExpenses + parseInt(exp)
            partsExpenses = partsExpenses + parseInt(exp)
          })
        }

        if (value[techInspectionItem][key].expensesLabor !== undefined) {
          value[techInspectionItem][key].expensesLabor.forEach(exp => {
            totalExpenses = totalExpenses + parseInt(exp)
            laborExpenses = laborExpenses + parseInt(exp)
          })
        }
      })
  }

  return (
    <>
      <Button
        color="primary"
        variant={'contained'}
        fullWidth
        size={'small'}
        onClick={() => setOpen(true)}
      >
        Акт осмотра авто
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="show-tech-title"
      >
        <ModalTitle id="show-tech-title" onClose={handleClose}>
          {'АКТ ОСМОТРА АВТО'}
        </ModalTitle>
        <DialogContent>
          <Grid container style={{ textAlign: 'left' }}>
            <Grid item xs={12} style={{ padding: '0px' }}>
              {!!value?.inspection &&
                !!value?.inspection?.inspectorInspectionComments && (
                  <div
                    style={{
                      borderColor: PRIMARY_COLORS[500],
                      border: 1,
                      borderStyle: 'solid',
                      padding: 5
                    }}
                  >
                    <Box mb={2}>Комментарий МП</Box>
                    <Box color={blueGrey[500]}>
                      {value?.inspection?.inspectorInspectionComments}
                    </Box>
                  </div>
                )}
              <Table>
                <TableBody>
                  {technicalInspectionList.map(inspectionType => {
                    return (
                      value[inspectionType] &&
                      Object.keys(value[inspectionType]).map(function (
                        key,
                        objIndex
                      ) {
                        if (
                          value[inspectionType][key]?.state?.includes('OK') ||
                          value[inspectionType][key]?.state?.includes(
                            'Не предусмотрено'
                          )
                        ) {
                          return null
                        }
                        return (
                          value[inspectionType][key]?.repairType !==
                            undefined &&
                          value[inspectionType][key]?.repairType.filter(
                            x => x !== ''
                          ).length !== 0 && (
                            <TableRow key={key + objIndex}>
                              <TableCell>
                                <div
                                  style={{
                                    fontWeight: '600',
                                    fontSize: '18px'
                                  }}
                                >
                                  {value[inspectionType][key].name}
                                </div>
                                <div>
                                  Повреждения:{' '}
                                  <b>
                                    {value[inspectionType][key].state
                                      .filter(
                                        x =>
                                          x !== '' &&
                                          x !== 'Заводской окрас детали'
                                      )
                                      .map(state => state)
                                      .join(', ')}
                                  </b>
                                </div>
                                <div>
                                  Работы:{' '}
                                  <b>
                                    {value[inspectionType][key]?.repairType
                                      .filter(x => x !== '')
                                      .map(repair => repair)
                                      .join(', ')}
                                  </b>
                                </div>
                                {value[inspectionType][key]?.comments && (
                                  <div>
                                    Комментарий:{' '}
                                    <b>
                                      {value[inspectionType][key]?.comments}
                                    </b>
                                  </div>
                                )}
                              </TableCell>
                            </TableRow>
                          )
                        )
                      })
                    )
                  })}
                </TableBody>
              </Table>
            </Grid>
          </Grid>
        </DialogContent>
      </Modal>
    </>
  )
}
